import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { CountryContextService } from './countryContext.service';

export interface Locale {
    lang: string;
    data: Object;
}

@Injectable({
    providedIn: 'root',
})
export class TranslationService {
    private langIds: any = [];
    constructor(
        private translate: TranslateService,
        private sessionBusiness: SessionBusiness,
        private countryContextService: CountryContextService
    ) {
        this.translate.setDefaultLang(`en`);
        this.setBycontext();
    }

    public setBycontext(): void {
        this.countryContextService.selectCountry(this.sessionBusiness.CountryIdContext);
        this.setLanguage(this.countryContextService.languageSelected.lang);
    }

    public setLanguage(lang: any) {
        if (lang) {
            this.translate.use(this.translate.getDefaultLang());
            this.translate.use(lang);
            localStorage.setItem('language', lang);
        }
    }
    public loadTranslations(...args: Locale[]): void {
        const locales = [...args];
        locales.forEach((locale) => {
            this.translate.setTranslation(locale.lang, locale.data, true);

            this.langIds.push(locale.lang);
        });

        this.translate.addLangs(this.langIds);
    }

    public getSelectedLanguage(): any {
        return localStorage.getItem('language') || this.translate.getDefaultLang();
    }
}
